import React, { useEffect, useState } from 'react';
import { ArrowLeft, ChevronDown } from 'lucide-react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, BarChart, Bar, CartesianGrid, PieChart, Pie, Cell, LineChart, Line, Legend } from 'recharts';
import { DERS_RENKLERI } from '../utils/constants';
interface Subject {
  id: string;
  title: string;
}
const subjects: Subject[] = [{
  id: 'turkce',
  title: 'Türkçe'
}, {
  id: 'matematik',
  title: 'Matematik'
}, {
  id: 'fen',
  title: 'Fen Bilimleri'
}, {
  id: 'inkılap',
  title: 'T.C. İnkılap Tarihi ve Atatürkçülük'
}, {
  id: 'ingilizce',
  title: 'İngilizce'
}, {
  id: 'din',
  title: 'Din Kültürü ve Ahlâk Bilgisi'
}];
// Topic lists for each subject
const topicsBySubject = {
  turkce: ['Sözcükte Anlam', 'Deyimler ve Atasözleri', 'Cümlede Anlam', 'Sözel Mantık / Görsel Okuma', 'Parçada Anlam', 'Söz Sanatları', 'Metin Türleri', 'Noktalama İşaretleri', 'Yazım Kuralları', 'Fiilimsiler', 'Cümlenin Öğeleri', 'Cümle Türleri', 'Anlatım Bozukluğu'],
  matematik: ['Çarpanlar ve Katlar', 'Üslü Sayılar', 'Köklü Sayılar', 'Veri Analizi', 'Olasılık', 'Cebirsel İfadeler', 'Doğrusal Denklemler ve Eğim', 'Eşitsizlikler', 'Üçgenler', 'Eşlik ve Benzerlik', 'Dönüşüm Geometrisi', 'Geometrik Cisimler'],
  fen: ['Mevsimler ve İklim', 'DNA ve Genetik Kod', 'Basınç', 'Madde ve Endüstri', 'Basit Makineler', 'Enerji Dönüşümleri ve Çevre Bilimi', 'Elektrik Yükleri ve Elektrik Enerjisi'],
  inkılap: ['Bir Kahraman Doğuyor', 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar', 'Milli Bir Destan: Ya İstiklal, Ya Ölüm', 'Atatürkçülük ve Çağdaşlaşan Türkiye', 'Demokratikleşme Çabaları', 'Atatürk Dönemi Dış Politika', "Atatürk'ün Ölümü ve Sonrası"],
  ingilizce: ['Friendship', 'Teen Life', 'In The Kitchen', 'On The Phone', 'The Internet', 'Adventures', 'Tourism', 'Chores', 'Science', 'Natural Forces'],
  din: ['Kader İnancı', 'Bir Peygamber Tanıyorum: Hz. Musa', 'Zekat ve Sadaka', 'Din ve Hayat', "Hz. Muhammed'in Örnekliği", "Kur'an-ı Kerim ve Özellikleri", "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem", 'İslam Dinine Göre Kötü Davranışlar', 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)', 'Hac ibadeti']
};
// TASK 1: Ensure data consistency by using a single source of truth for exam data
// All historical exam data - this is now the single source of truth for all exam data
const allExamsData = [{
  id: 'lgs8',
  name: 'LGS 8',
  date: '2024-01-30',
  totalCorrect: 85,
  totalWrong: 3,
  totalEmpty: 2,
  totalNet: 84,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 18,
    wrong: 1,
    empty: 1,
    net: 17.67,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 19,
    wrong: 0,
    empty: 1,
    net: 19,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 4,
      wrong: 0,
      empty: 1,
      net: 4,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 19,
    wrong: 1,
    empty: 0,
    net: 18.67,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 3,
      wrong: 1,
      empty: 0,
      net: 2.67,
      questions: 4
    }, {
      topic: 'Basit Makineler',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 9,
    wrong: 1,
    empty: 0,
    net: 8.67,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Atatürk'ün Ölümü ve Sonrası",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'İslam Dinine Göre Kötü Davranışlar',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Natural Forces',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }]
}, {
  id: 'lgs7',
  name: 'LGS 7',
  date: '2023-12-15',
  totalCorrect: 80,
  totalWrong: 5,
  totalEmpty: 5,
  totalNet: 78.33,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 16,
    wrong: 2,
    empty: 2,
    net: 15.33,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 18,
    wrong: 1,
    empty: 1,
    net: 17.67,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 3,
      wrong: 1,
      empty: 1,
      net: 2.67,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 18,
    wrong: 1,
    empty: 1,
    net: 17.67,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 3,
      wrong: 0,
      empty: 1,
      net: 3,
      questions: 4
    }, {
      topic: 'Basit Makineler',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 8,
    wrong: 1,
    empty: 1,
    net: 7.67,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Atatürk'ün Ölümü ve Sonrası",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'İslam Dinine Göre Kötü Davranışlar',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Natural Forces',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }]
}, {
  id: 'lgs6',
  name: 'LGS 6',
  date: '2023-12-01',
  totalCorrect: 78,
  totalWrong: 6,
  totalEmpty: 6,
  totalNet: 76,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 15,
    wrong: 2,
    empty: 3,
    net: 14.33,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 17,
    wrong: 2,
    empty: 1,
    net: 16.33,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 4,
      wrong: 0,
      empty: 1,
      net: 4,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 0,
      wrong: 1,
      empty: 0,
      net: -0.33,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 18,
    wrong: 1,
    empty: 1,
    net: 17.67,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 3,
      wrong: 0,
      empty: 1,
      net: 3,
      questions: 4
    }, {
      topic: 'Basit Makineler',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 8,
    wrong: 1,
    empty: 1,
    net: 7.67,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Atatürk'ün Ölümü ve Sonrası",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'İslam Dinine Göre Kötü Davranışlar',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Natural Forces',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }]
}, {
  id: 'lgs5',
  name: 'LGS 5',
  date: '2023-11-15',
  totalCorrect: 75,
  totalWrong: 8,
  totalEmpty: 7,
  totalNet: 72.33,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 14,
    wrong: 3,
    empty: 3,
    net: 13,
    questions: 20,
    topics: []
  }, {
    subject: 'TÜRKÇE',
    correct: 16,
    wrong: 2,
    empty: 2,
    net: 15.33,
    questions: 20,
    topics: []
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 17,
    wrong: 2,
    empty: 1,
    net: 16.33,
    questions: 20,
    topics: []
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 8,
    wrong: 1,
    empty: 1,
    net: 7.67,
    questions: 10,
    topics: []
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: []
  }, {
    subject: 'İNGİLİZCE',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: []
  }]
}, {
  id: 'lgs4',
  name: 'LGS 4',
  date: '2023-11-01',
  totalCorrect: 70,
  totalWrong: 10,
  totalEmpty: 10,
  totalNet: 66.67,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 12,
    wrong: 4,
    empty: 4,
    net: 10.67,
    questions: 20,
    topics: []
  }, {
    subject: 'TÜRKÇE',
    correct: 15,
    wrong: 3,
    empty: 2,
    net: 14,
    questions: 20,
    topics: []
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 16,
    wrong: 2,
    empty: 2,
    net: 15.33,
    questions: 20,
    topics: []
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 7,
    wrong: 1,
    empty: 2,
    net: 6.67,
    questions: 10,
    topics: []
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: []
  }, {
    subject: 'İNGİLİZCE',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: []
  }]
}, {
  id: 'lgs3',
  name: 'LGS 3',
  date: '2023-10-15',
  totalCorrect: 68,
  totalWrong: 12,
  totalEmpty: 10,
  totalNet: 64,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 11,
    wrong: 5,
    empty: 4,
    net: 9.33,
    questions: 20,
    topics: []
  }, {
    subject: 'TÜRKÇE',
    correct: 14,
    wrong: 4,
    empty: 2,
    net: 12.67,
    questions: 20,
    topics: []
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 16,
    wrong: 2,
    empty: 2,
    net: 15.33,
    questions: 20,
    topics: []
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 7,
    wrong: 1,
    empty: 2,
    net: 6.67,
    questions: 10,
    topics: []
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: []
  }, {
    subject: 'İNGİLİZCE',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: []
  }]
}, {
  id: 'lgs2',
  name: 'LGS 2',
  date: '2023-10-01',
  totalCorrect: 65,
  totalWrong: 15,
  totalEmpty: 10,
  totalNet: 60,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 10,
    wrong: 6,
    empty: 4,
    net: 8,
    questions: 20,
    topics: []
  }, {
    subject: 'TÜRKÇE',
    correct: 13,
    wrong: 5,
    empty: 2,
    net: 11.33,
    questions: 20,
    topics: []
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 15,
    wrong: 3,
    empty: 2,
    net: 14,
    questions: 20,
    topics: []
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 7,
    wrong: 1,
    empty: 2,
    net: 6.67,
    questions: 10,
    topics: []
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: []
  }, {
    subject: 'İNGİLİZCE',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: []
  }]
}, {
  id: 'lgs1',
  name: 'LGS 1',
  date: '2023-09-15',
  totalCorrect: 60,
  totalWrong: 18,
  totalEmpty: 12,
  totalNet: 54,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 8,
    wrong: 8,
    empty: 4,
    net: 5.33,
    questions: 20,
    topics: []
  }, {
    subject: 'TÜRKÇE',
    correct: 12,
    wrong: 6,
    empty: 2,
    net: 10,
    questions: 20,
    topics: []
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 14,
    wrong: 3,
    empty: 3,
    net: 13,
    questions: 20,
    topics: []
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 6,
    wrong: 1,
    empty: 3,
    net: 5.67,
    questions: 10,
    topics: []
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: []
  }, {
    subject: 'İNGİLİZCE',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: []
  }]
}];
// Create a consistent chart data source derived from allExamsData
const lgsExamData = allExamsData.slice() // Create a copy to avoid modifying the original array
.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()) // Sort by date in ascending order
.map(exam => ({
  name: exam.name,
  date: exam.date,
  net: exam.totalNet,
  maxNet: 90 // Maximum possible net score
}));
// Overall statistics - derived from allExamsData for consistency
const overallStats = {
  totalExams: allExamsData.length,
  averageNet: parseFloat((allExamsData.reduce((sum, exam) => sum + exam.totalNet, 0) / allExamsData.length).toFixed(2)),
  highestNet: Math.max(...allExamsData.map(exam => exam.totalNet)),
  lowestNet: Math.min(...allExamsData.map(exam => exam.totalNet)),
  totalQuestions: 90,
  strongestSubject: 'Fen Bilimleri',
  weakestSubject: 'İngilizce'
};
// Expanded topic analysis data for all subjects
const topicAnalysisData = {
  MATEMATİK: [{
    topic: 'Çarpanlar ve Katlar',
    correct: 45,
    wrong: 3,
    empty: 0,
    totalQuestions: 48,
    accuracy: 93.75,
    errorCount: 3
  }, {
    topic: 'Üslü Sayılar',
    correct: 42,
    wrong: 4,
    empty: 2,
    totalQuestions: 48,
    accuracy: 87.5,
    errorCount: 4
  }, {
    topic: 'Köklü Sayılar',
    correct: 40,
    wrong: 5,
    empty: 3,
    totalQuestions: 48,
    accuracy: 83.33,
    errorCount: 5
  }, {
    topic: 'Veri Analizi',
    correct: 22,
    wrong: 2,
    empty: 0,
    totalQuestions: 24,
    accuracy: 91.67,
    errorCount: 2
  }, {
    topic: 'Olasılık',
    correct: 20,
    wrong: 3,
    empty: 1,
    totalQuestions: 24,
    accuracy: 83.33,
    errorCount: 3
  }, {
    topic: 'Cebirsel İfadeler',
    correct: 36,
    wrong: 9,
    empty: 3,
    totalQuestions: 48,
    accuracy: 75.0,
    errorCount: 9
  }, {
    topic: 'Doğrusal Denklemler ve Eğim',
    correct: 38,
    wrong: 7,
    empty: 3,
    totalQuestions: 48,
    accuracy: 79.17,
    errorCount: 7
  }, {
    topic: 'Eşitsizlikler',
    correct: 16,
    wrong: 6,
    empty: 2,
    totalQuestions: 24,
    accuracy: 66.67,
    errorCount: 6
  }, {
    topic: 'Üçgenler',
    correct: 32,
    wrong: 7,
    empty: 1,
    totalQuestions: 40,
    accuracy: 80.0,
    errorCount: 7
  }, {
    topic: 'Eşlik ve Benzerlik',
    correct: 18,
    wrong: 4,
    empty: 2,
    totalQuestions: 24,
    accuracy: 75.0,
    errorCount: 4
  }, {
    topic: 'Dönüşüm Geometrisi',
    correct: 16,
    wrong: 5,
    empty: 3,
    totalQuestions: 24,
    accuracy: 66.67,
    errorCount: 5
  }, {
    topic: 'Geometrik Cisimler',
    correct: 25,
    wrong: 6,
    empty: 1,
    totalQuestions: 32,
    accuracy: 78.13,
    errorCount: 6
  }],
  TÜRKÇE: [{
    topic: 'Sözcükte Anlam',
    correct: 38,
    wrong: 2,
    empty: 0,
    totalQuestions: 40,
    accuracy: 95.0,
    errorCount: 2
  }, {
    topic: 'Deyimler ve Atasözleri',
    correct: 35,
    wrong: 3,
    empty: 2,
    totalQuestions: 40,
    accuracy: 87.5,
    errorCount: 3
  }, {
    topic: 'Cümlede Anlam',
    correct: 37,
    wrong: 3,
    empty: 0,
    totalQuestions: 40,
    accuracy: 92.5,
    errorCount: 3
  }, {
    topic: 'Sözel Mantık / Görsel Okuma',
    correct: 28,
    wrong: 4,
    empty: 0,
    totalQuestions: 32,
    accuracy: 87.5,
    errorCount: 4
  }, {
    topic: 'Parçada Anlam',
    correct: 55,
    wrong: 7,
    empty: 2,
    totalQuestions: 64,
    accuracy: 85.94,
    errorCount: 7
  }, {
    topic: 'Söz Sanatları',
    correct: 20,
    wrong: 3,
    empty: 1,
    totalQuestions: 24,
    accuracy: 83.33,
    errorCount: 3
  }, {
    topic: 'Metin Türleri',
    correct: 28,
    wrong: 3,
    empty: 1,
    totalQuestions: 32,
    accuracy: 87.5,
    errorCount: 3
  }, {
    topic: 'Noktalama İşaretleri',
    correct: 25,
    wrong: 2,
    empty: 1,
    totalQuestions: 28,
    accuracy: 89.29,
    errorCount: 2
  }, {
    topic: 'Yazım Kuralları',
    correct: 26,
    wrong: 4,
    empty: 2,
    totalQuestions: 32,
    accuracy: 81.25,
    errorCount: 4
  }, {
    topic: 'Fiilimsiler',
    correct: 15,
    wrong: 6,
    empty: 3,
    totalQuestions: 24,
    accuracy: 62.5,
    errorCount: 6
  }, {
    topic: 'Cümlenin Öğeleri',
    correct: 30,
    wrong: 5,
    empty: 1,
    totalQuestions: 36,
    accuracy: 83.33,
    errorCount: 5
  }, {
    topic: 'Cümle Türleri',
    correct: 22,
    wrong: 7,
    empty: 3,
    totalQuestions: 32,
    accuracy: 68.75,
    errorCount: 7
  }, {
    topic: 'Anlatım Bozukluğu',
    correct: 14,
    wrong: 9,
    empty: 1,
    totalQuestions: 24,
    accuracy: 58.33,
    errorCount: 9
  }],
  'FEN BİLİMLERİ': [{
    topic: 'Mevsimler ve İklim',
    correct: 25,
    wrong: 3,
    empty: 0,
    totalQuestions: 28,
    accuracy: 89.29,
    errorCount: 3
  }, {
    topic: 'DNA ve Genetik Kod',
    correct: 38,
    wrong: 4,
    empty: 2,
    totalQuestions: 44,
    accuracy: 86.36,
    errorCount: 4
  }, {
    topic: 'Basınç',
    correct: 18,
    wrong: 4,
    empty: 2,
    totalQuestions: 24,
    accuracy: 75.0,
    errorCount: 4
  }, {
    topic: 'Madde ve Endüstri',
    correct: 32,
    wrong: 10,
    empty: 2,
    totalQuestions: 44,
    accuracy: 72.73,
    errorCount: 10
  }, {
    topic: 'Basit Makineler',
    correct: 22,
    wrong: 2,
    empty: 0,
    totalQuestions: 24,
    accuracy: 91.67,
    errorCount: 2
  }, {
    topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
    correct: 28,
    wrong: 3,
    empty: 1,
    totalQuestions: 32,
    accuracy: 87.5,
    errorCount: 3
  }, {
    topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
    correct: 28,
    wrong: 7,
    empty: 1,
    totalQuestions: 36,
    accuracy: 77.78,
    errorCount: 7
  }],
  'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK': [{
    topic: 'Bir Kahraman Doğuyor',
    correct: 22,
    wrong: 2,
    empty: 0,
    totalQuestions: 24,
    accuracy: 91.67,
    errorCount: 2
  }, {
    topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
    correct: 34,
    wrong: 4,
    empty: 2,
    totalQuestions: 40,
    accuracy: 85.0,
    errorCount: 4
  }, {
    topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
    correct: 30,
    wrong: 6,
    empty: 0,
    totalQuestions: 36,
    accuracy: 83.33,
    errorCount: 6
  }, {
    topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
    correct: 25,
    wrong: 3,
    empty: 0,
    totalQuestions: 28,
    accuracy: 89.29,
    errorCount: 3
  }, {
    topic: 'Demokratikleşme Çabaları',
    correct: 15,
    wrong: 2,
    empty: 1,
    totalQuestions: 18,
    accuracy: 83.33,
    errorCount: 2
  }, {
    topic: 'Atatürk Dönemi Dış Politika',
    correct: 12,
    wrong: 6,
    empty: 0,
    totalQuestions: 18,
    accuracy: 66.67,
    errorCount: 6
  }, {
    topic: "Atatürk'ün Ölümü ve Sonrası",
    correct: 12,
    wrong: 2,
    empty: 1,
    totalQuestions: 15,
    accuracy: 80.0,
    errorCount: 2
  }],
  İNGİLİZCE: [{
    topic: 'Friendship',
    correct: 18,
    wrong: 2,
    empty: 0,
    totalQuestions: 20,
    accuracy: 90.0,
    errorCount: 2
  }, {
    topic: 'Teen Life',
    correct: 19,
    wrong: 2,
    empty: 1,
    totalQuestions: 22,
    accuracy: 86.36,
    errorCount: 2
  }, {
    topic: 'In The Kitchen',
    correct: 14,
    wrong: 1,
    empty: 0,
    totalQuestions: 15,
    accuracy: 93.33,
    errorCount: 1
  }, {
    topic: 'On The Phone',
    correct: 15,
    wrong: 3,
    empty: 0,
    totalQuestions: 18,
    accuracy: 83.33,
    errorCount: 3
  }, {
    topic: 'The Internet',
    correct: 20,
    wrong: 4,
    empty: 0,
    totalQuestions: 24,
    accuracy: 83.33,
    errorCount: 4
  }, {
    topic: 'Adventures',
    correct: 16,
    wrong: 3,
    empty: 1,
    totalQuestions: 20,
    accuracy: 80.0,
    errorCount: 3
  }, {
    topic: 'Tourism',
    correct: 14,
    wrong: 2,
    empty: 2,
    totalQuestions: 18,
    accuracy: 77.78,
    errorCount: 2
  }, {
    topic: 'Chores',
    correct: 12,
    wrong: 1,
    empty: 2,
    totalQuestions: 15,
    accuracy: 80.0,
    errorCount: 1
  }, {
    topic: 'Science',
    correct: 22,
    wrong: 4,
    empty: 1,
    totalQuestions: 27,
    accuracy: 81.48,
    errorCount: 4
  }, {
    topic: 'Natural Forces',
    correct: 18,
    wrong: 3,
    empty: 3,
    totalQuestions: 24,
    accuracy: 75.0,
    errorCount: 3
  }],
  'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ': [{
    topic: 'Kader İnancı',
    correct: 22,
    wrong: 2,
    empty: 0,
    totalQuestions: 24,
    accuracy: 91.67,
    errorCount: 2
  }, {
    topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
    correct: 16,
    wrong: 2,
    empty: 0,
    totalQuestions: 18,
    accuracy: 88.89,
    errorCount: 2
  }, {
    topic: 'Zekat ve Sadaka',
    correct: 14,
    wrong: 1,
    empty: 0,
    totalQuestions: 15,
    accuracy: 93.33,
    errorCount: 1
  }, {
    topic: 'Din ve Hayat',
    correct: 18,
    wrong: 2,
    empty: 1,
    totalQuestions: 21,
    accuracy: 85.71,
    errorCount: 2
  }, {
    topic: "Hz. Muhammed'in Örnekliği",
    correct: 25,
    wrong: 2,
    empty: 0,
    totalQuestions: 27,
    accuracy: 92.59,
    errorCount: 2
  }, {
    topic: "Kur'an-ı Kerim ve Özellikleri",
    correct: 20,
    wrong: 3,
    empty: 1,
    totalQuestions: 24,
    accuracy: 83.33,
    errorCount: 3
  }, {
    topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
    correct: 16,
    wrong: 1,
    empty: 1,
    totalQuestions: 18,
    accuracy: 88.89,
    errorCount: 1
  }, {
    topic: 'İslam Dinine Göre Kötü Davranışlar',
    correct: 12,
    wrong: 5,
    empty: 1,
    totalQuestions: 18,
    accuracy: 66.67,
    errorCount: 5
  }, {
    topic: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
    correct: 13,
    wrong: 2,
    empty: 0,
    totalQuestions: 15,
    accuracy: 86.67,
    errorCount: 2
  }, {
    topic: 'Hac ibadeti',
    correct: 12,
    wrong: 3,
    empty: 3,
    totalQuestions: 18,
    accuracy: 66.67,
    errorCount: 3
  }]
};
// Helper function to calculate net score
const calculateNet = (correct, wrong) => correct - wrong / 3;
// Function to get topics for a subject
const getTopicsForSubject = subjectKey => {
  return topicsBySubject[subjectKey.toLowerCase()] || [];
};
// Helper function to get topic data from exam data
const getTopicData = (exam, subject, topic) => {
  const subjectData = exam.subjects.find(s => s.subject === subject);
  if (!subjectData) return null;
  const topicData = subjectData.topics.find(t => t.topic === topic);
  return topicData || {
    correct: 0,
    wrong: 0,
    empty: 0,
    net: 0,
    questions: 0
  };
};
// Helper function to get the most problematic topics for each subject
const getMostProblematicTopics = (subject, limit = 3) => {
  if (!topicAnalysisData[subject]) return [];
  return [...topicAnalysisData[subject]].sort((a, b) => a.accuracy - b.accuracy).slice(0, limit);
};
export function Analysis() {
  const [activeTab, setActiveTab] = useState('all');
  const [selectedExam, setSelectedExam] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState<Subject | null>(null);
  const [selectedTopic, setSelectedTopic] = useState<string | null>(null);
  const [selectedTopicSubject, setSelectedTopicSubject] = useState('MATEMATİK');
  const [showExamDropdown, setShowExamDropdown] = useState(false);
  const [showSubjectDropdown, setShowSubjectDropdown] = useState(false);
  const [currentExam, setCurrentExam] = useState(allExamsData[0]);
  const [selectedMistakeFilterSubject, setSelectedMistakeFilterSubject] = useState('Tüm Dersler');
  const [showMistakeFilterSubjectDropdown, setShowMistakeFilterSubjectDropdown] = useState(false);
  const [selectedSubjectForTopics, setSelectedSubjectForTopics] = useState<string | null>(null);
  const [activeSubjectTab, setActiveSubjectTab] = useState('MATEMATİK');
  const handleExamClick = exam => {
    setCurrentExam(exam);
    setShowExamDropdown(false);
  };
  // Custom tooltip for charts - Updated to only show "Net"
  const CustomTooltip = ({
    active,
    payload,
    label
  }) => {
    if (active && payload && payload.length) {
      return <div className="p-3 bg-gray-900 border border-gray-700 rounded-lg shadow-lg" data-id="element-1394">
          <p className="text-sm font-medium text-white" data-id="element-1395">{`${label}`}</p>
          {payload.map((entry, index) => entry.name !== 'Maksimum Net' && <p key={index} className="text-sm" style={{
          color: entry.color
        }} data-id="element-1396">
                  {`Net: ${entry.value}`}
                </p>)}
        </div>;
    }
    return null;
  };
  // Get topics for the currently selected subject tab
  const getTopicsForActiveSubject = () => {
    const subject = currentExam.subjects.find(s => s.subject === activeSubjectTab);
    if (!subject || !subject.topics || subject.topics.length === 0) {
      // If no specific topics available, try to get generic topics
      const subjectKey = Object.keys(topicsBySubject).find(key => activeSubjectTab.toLowerCase().includes(key.toLowerCase()));
      if (subjectKey) {
        return topicsBySubject[subjectKey].map(topic => ({
          topic,
          correct: 0,
          wrong: 0,
          empty: 0,
          net: 0,
          questions: 0,
          successRate: 0
        }));
      }
      return [];
    }
    // Map the topics to include success rate
    return subject.topics.map(topic => ({
      ...topic,
      successRate: topic.questions > 0 ? topic.net / topic.questions * 100 : 0
    }));
  };
  if (selectedSubject && !selectedTopic) {
    // Get border color based on subject
    let borderColor = 'border-purple-500'; // Default
    switch (selectedSubject.id) {
      case 'turkce':
        borderColor = 'border-red-500';
        break;
      case 'matematik':
        borderColor = 'border-blue-500';
        break;
      case 'fen':
        borderColor = 'border-emerald-500';
        break;
      case 'inkılap':
        borderColor = 'border-amber-700';
        break;
      case 'din':
        borderColor = 'border-blue-900';
        break;
      case 'ingilizce':
        borderColor = 'border-purple-500';
        break;
    }
    const topics = topicsBySubject[selectedSubject.id as keyof typeof topicsBySubject] || [];
    return <div className="space-y-6" data-id="element-1397">
        <div className="flex items-center gap-4" data-id="element-1398">
          <button onClick={() => setSelectedSubject(null)} className="flex items-center gap-2 px-4 py-2 rounded-lg border border-white text-white hover:bg-white/10 transition-all" data-id="element-1399">
            <ArrowLeft className="w-5 h-5" data-id="element-1400" />
            Geri
          </button>
          <h1 className="text-2xl font-bold" data-id="element-1401">{selectedSubject.title}</h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1402">
          {topics.map(topic => <div key={topic} onClick={() => setSelectedTopic(topic)} className={`relative p-[1px] rounded-lg overflow-hidden border ${borderColor} cursor-pointer hover:shadow-[0_0_10px_rgba(255,255,255,0.2)] transition-all duration-300`} data-id="element-1403">
              <div className="relative p-6 bg-black/95 rounded-lg" data-id="element-1404">
                <h3 className="text-lg font-medium text-center" data-id="element-1405">{topic}</h3>
              </div>
            </div>)}
        </div>
      </div>;
  }
  // Topic detail view would go here
  if (selectedTopic) {
    return <div className="space-y-6" data-id="element-1406">
        <div className="flex items-center gap-4" data-id="element-1407">
          <button onClick={() => setSelectedTopic(null)} className="flex items-center gap-2 px-4 py-2 rounded-lg border border-white text-white hover:bg-white/10 transition-all" data-id="element-1408">
            <ArrowLeft className="w-5 h-5" data-id="element-1409" />
            Geri
          </button>
          <h1 className="text-2xl font-bold" data-id="element-1410">
            {selectedSubject?.title} - {selectedTopic}
          </h1>
        </div>
        <div className="text-center py-12 text-gray-400" data-id="element-1411">
          Bu konu için henüz analiz bulunmuyor
        </div>
      </div>;
  }
  // Function to render topic cards for a subject
  const renderSubjectTopicCards = subject => {
    const subjectData = currentExam.subjects.find(s => s.subject === subject.subject);
    if (!subjectData) return null;
    // Get the subject key for topic mapping
    const subjectKey = Object.keys(topicsBySubject).find(key => subject.subject.toLowerCase().includes(key.toLowerCase()));
    // Get topics for this subject
    const topics = subjectKey ? getTopicsForSubject(subjectKey) : [];
    // Get the gradient class for this subject
    const gradientClass = DERS_RENKLERI[subject.subject] || 'from-purple-600 to-indigo-600';
    return <div className="space-y-6" data-id="element-1412">
        <div className="flex items-center gap-4" data-id="element-1413">
          <button onClick={() => setSelectedSubjectForTopics(null)} className="flex items-center gap-2 px-4 py-2 rounded-lg border border-white text-white hover:bg-white/10 transition-all" data-id="element-1414">
            <ArrowLeft className="w-5 h-5" data-id="element-1415" />
            Geri
          </button>
          <h1 className="text-2xl font-bold" data-id="element-1416">{subject.subject}</h1>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1417">
          {topics.map(topic => {
          const topicData = getTopicData(currentExam, subject.subject, topic);
          const topicSuccessRate = topicData.questions > 0 ? topicData.net / topicData.questions * 100 : 0;
          return <div key={topic} className={`p-[1px] rounded-xl overflow-hidden bg-gradient-to-r ${gradientClass}`} data-id="element-1418">
                <div className="p-4 bg-black/90 rounded-xl" data-id="element-1419">
                  <h3 className="text-lg font-semibold mb-3" data-id="element-1420">{topic}</h3>
                  <div className="grid grid-cols-3 gap-2 mb-4" data-id="element-1421">
                    <div className="text-center" data-id="element-1422">
                      <div className="text-lg font-bold text-green-500" data-id="element-1423">
                        {topicData.correct}
                      </div>
                      <div className="text-xs text-gray-400" data-id="element-1424">Doğru</div>
                    </div>
                    <div className="text-center" data-id="element-1425">
                      <div className="text-lg font-bold text-red-500" data-id="element-1426">
                        {topicData.wrong}
                      </div>
                      <div className="text-xs text-gray-400" data-id="element-1427">Yanlış</div>
                    </div>
                    <div className="text-center" data-id="element-1428">
                      <div className="text-lg font-bold text-gray-500" data-id="element-1429">
                        {topicData.empty}
                      </div>
                      <div className="text-xs text-gray-400" data-id="element-1430">Boş</div>
                    </div>
                  </div>
                  <div className="flex justify-between text-sm mb-1" data-id="element-1431">
                    <span className="text-gray-300" data-id="element-1432">Başarı</span>
                    <span className="text-white" data-id="element-1433">
                      {topicData.questions > 0 ? `${topicData.net.toFixed(2)} / ${topicData.questions}` : '0/0'}
                    </span>
                  </div>
                  <div className="w-full h-2 bg-gray-800 rounded-full overflow-hidden" data-id="element-1434">
                    {topicData.questions > 0 ? <div className={`h-full bg-gradient-to-r ${gradientClass}`} style={{
                  width: `${topicSuccessRate}%`
                }} data-id="element-1435" /> : <div className="h-full bg-gray-700 opacity-30" style={{
                  width: '0%'
                }} data-id="element-1436" />}
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>;
  };
  return <div className="space-y-6" data-id="element-1437">
      <h1 className="text-2xl font-bold" data-id="element-1438">Sınav Analizleri</h1>
      <div className="p-[1px] rounded-lg bg-gradient-to-r from-purple-800 to-purple-600" data-id="element-1439">
        <div className="p-1 bg-black/90 rounded-lg" data-id="element-1440">
          <div className="grid grid-cols-3 gap-1" data-id="element-1441">
            <button onClick={() => setActiveTab('all')} className={`px-4 py-2 rounded-lg transition-colors ${activeTab === 'all' ? 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white' : 'bg-black/60 text-gray-400 hover:bg-black/40'}`} data-id="element-1442">
              Tüm Denemeler
            </button>
            <button onClick={() => setActiveTab('last')} className={`px-4 py-2 rounded-lg transition-colors ${activeTab === 'last' ? 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white' : 'bg-black/60 text-gray-400 hover:bg-black/40'}`} data-id="element-1443">
              Son Deneme
            </button>
            <button onClick={() => setActiveTab('topic')} className={`px-4 py-2 rounded-lg transition-colors ${activeTab === 'topic' ? 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white' : 'bg-black/60 text-gray-400 hover:bg-black/40'}`} data-id="element-1444">
              Konu Bazlı Genel Analiz
            </button>
          </div>
        </div>
      </div>
      {activeTab === 'all' && <div className="space-y-6" data-id="element-1445">
          {/* Genel İstatistikler */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1446">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-1447">
              <h2 className="text-xl font-bold mb-4" data-id="element-1448">Genel İstatistikler</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-1449">
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1450">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-1451">
                    <div className="text-sm text-gray-400" data-id="element-1452">Toplam Deneme</div>
                    <div className="text-2xl font-bold text-white" data-id="element-1453">
                      {overallStats.totalExams}
                    </div>
                  </div>
                </div>
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1454">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-1455">
                    <div className="text-sm text-gray-400" data-id="element-1456">Ortalama Net</div>
                    <div className="text-2xl font-bold text-white" data-id="element-1457">
                      {overallStats.averageNet.toFixed(2)}
                    </div>
                  </div>
                </div>
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1458">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-1459">
                    <div className="text-sm text-gray-400" data-id="element-1460">En Yüksek Net</div>
                    <div className="text-2xl font-bold text-white" data-id="element-1461">
                      {overallStats.highestNet}
                    </div>
                  </div>
                </div>
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1462">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-1463">
                    <div className="text-sm text-gray-400" data-id="element-1464">En Düşük Net</div>
                    <div className="text-2xl font-bold text-white" data-id="element-1465">
                      {overallStats.lowestNet}
                    </div>
                  </div>
                </div>
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1466">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-1467">
                    <div className="text-sm text-gray-400" data-id="element-1468">
                      En Başarılı Ders
                    </div>
                    <div className="text-2xl font-bold text-white" data-id="element-1469">
                      {overallStats.strongestSubject}
                    </div>
                  </div>
                </div>
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1470">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-1471">
                    <div className="text-sm text-gray-400" data-id="element-1472">En Zayıf Ders</div>
                    <div className="text-2xl font-bold text-white" data-id="element-1473">
                      {overallStats.weakestSubject}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Deneme Sınavı Sonuçları Grafiği - TASK 1: Updated to show chronological order */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1474">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-1475">
              <h2 className="text-xl font-bold mb-4" data-id="element-1476">
                Deneme Sınavı Sonuçları
              </h2>
              <div className="h-80" data-id="element-1477">
                <ResponsiveContainer width="100%" height="100%" data-id="element-1478">
                  <LineChart data={lgsExamData} margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5
              }} data-id="element-1479">
                    <CartesianGrid strokeDasharray="3 3" stroke="#333" data-id="element-1480" />
                    <XAxis dataKey="name" stroke="#999" data-id="element-1481" />
                    <YAxis stroke="#999" domain={[0, 90]} ticks={[0, 15, 30, 45, 60, 75, 90]} data-id="element-1482" />
                    <Tooltip content={<CustomTooltip data-id="element-1484" />} data-id="element-1483" />
                    <Legend data-id="element-1485" />
                    <Line type="monotone" dataKey="net" name="Net" stroke="#8884d8" strokeWidth={2} dot={{
                  r: 6
                }} activeDot={{
                  r: 8
                }} data-id="element-1486" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
          {/* En Çok Hata Yapılan Konular */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1487">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-1488">
              <h2 className="text-xl font-bold mb-6" data-id="element-1489">
                En Çok Hata Yapılan Konular
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1490">
                {Object.keys(topicAnalysisData).map(subject => {
              const problemTopics = getMostProblematicTopics(subject, 3);
              const gradientClass = DERS_RENKLERI[subject] || 'from-purple-600 to-indigo-600';
              return <div key={subject} className={`p-[1px] rounded-xl overflow-hidden bg-gradient-to-r ${gradientClass}`} data-id="element-1491">
                      <div className="p-4 bg-black/95 rounded-xl h-full" data-id="element-1492">
                        <h3 className="text-lg font-bold mb-4 border-b border-gray-800 pb-2" data-id="element-1493">
                          {subject}
                        </h3>
                        <div className="space-y-4" data-id="element-1494">
                          {problemTopics.map(topic => <div key={topic.topic} className="space-y-2" data-id="element-1495">
                              <div className="flex justify-between items-center" data-id="element-1496">
                                <span className="text-gray-300 font-medium" data-id="element-1497">
                                  {topic.topic}
                                </span>
                              </div>
                              <div className="flex justify-between items-center text-sm" data-id="element-1498">
                                <span className="text-red-400" data-id="element-1499">
                                  {topic.wrong} Yanlış
                                </span>
                                <span className="text-gray-400" data-id="element-1500">
                                  Başarı: {topic.accuracy.toFixed(1)}%
                                </span>
                              </div>
                              <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-1501">
                                <div className={`h-full bg-gradient-to-r ${gradientClass}`} style={{
                          width: `${topic.accuracy}%`
                        }} data-id="element-1502" />
                              </div>
                            </div>)}
                        </div>
                      </div>
                    </div>;
            })}
              </div>
            </div>
          </div>
        </div>}
      {activeTab === 'last' && <div className="space-y-6" data-id="element-1503">
          {selectedSubjectForTopics ?
      // Show topic details for the selected subject
      renderSubjectTopicCards(currentExam.subjects.find(s => s.subject === selectedSubjectForTopics)) : <>
              {/* Son Deneme Özeti - Modified layout with centered pie chart and stats below */}
              <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1504">
                <div className="p-6 bg-black/90 rounded-xl" data-id="element-1505">
                  <div className="flex flex-col md:flex-row justify-between md:items-center mb-6" data-id="element-1506">
                    <div className="relative" data-id="element-1507">
                      <button onClick={() => setShowExamDropdown(!showExamDropdown)} className="flex items-center gap-2 px-4 py-2 bg-white/5 rounded-lg hover:bg-white/10 transition-colors" data-id="element-1508">
                        <span className="text-xl font-bold" data-id="element-1509">
                          {currentExam.name}
                        </span>
                        <span className="text-gray-400" data-id="element-1510">
                          {new Date(currentExam.date).toLocaleDateString('tr-TR', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                        </span>
                        <ChevronDown className={`w-5 h-5 transition-transform ${showExamDropdown ? 'rotate-180' : ''}`} data-id="element-1511" />
                      </button>
                      {showExamDropdown && <div className="absolute top-full left-0 mt-1 z-10 w-full bg-gray-900/95 border border-gray-700 rounded-lg shadow-lg py-1 max-h-60 overflow-y-auto" data-id="element-1512">
                          {allExamsData.map(exam => <button key={exam.id} onClick={() => handleExamClick(exam)} className="w-full text-left px-4 py-2 hover:bg-purple-500/20 transition-colors flex justify-between items-center" data-id="element-1513">
                              <span data-id="element-1514">{exam.name}</span>
                              <span className="text-sm text-gray-400" data-id="element-1515">
                                {new Date(exam.date).toLocaleDateString('tr-TR', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                      })}
                              </span>
                            </button>)}
                        </div>}
                    </div>
                  </div>
                  {/* Centered Pie Chart with stats below */}
                  <div className="flex flex-col items-center" data-id="element-1516">
                    <div className="h-80 w-full max-w-md" data-id="element-1517">
                      <ResponsiveContainer width="100%" height="100%" data-id="element-1518">
                        <PieChart data-id="element-1519">
                          <Pie data={[{
                      name: 'Doğru',
                      value: currentExam.totalCorrect
                    }, {
                      name: 'Yanlış',
                      value: currentExam.totalWrong
                    }, {
                      name: 'Boş',
                      value: currentExam.totalEmpty
                    }]} cx="50%" cy="50%" innerRadius={80} outerRadius={120} fill="#8884d8" paddingAngle={5} dataKey="value" labelLine={false} label={({
                      name,
                      percent
                    }) => {
                      return `${name}: ${(percent * 100).toFixed(1)}%`;
                    }} data-id="element-1520">
                            <Cell fill="#4ade80" data-id="element-1521" />
                            <Cell fill="#f87171" data-id="element-1522" />
                            <Cell fill="#94a3b8" data-id="element-1523" />
                          </Pie>
                          <Tooltip data-id="element-1524" />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                    <div className="mt-4 grid grid-cols-4 gap-8" data-id="element-1525">
                      <div className="flex flex-col items-center" data-id="element-1526">
                        <span className="text-sm text-gray-400" data-id="element-1527">
                          Toplam Net
                        </span>
                        <span className="text-2xl font-bold text-white" data-id="element-1528">
                          {currentExam.totalNet}
                        </span>
                      </div>
                      <div className="flex flex-col items-center" data-id="element-1529">
                        <span className="text-sm text-gray-400" data-id="element-1530">Doğru</span>
                        <span className="text-2xl font-bold text-green-500" data-id="element-1531">
                          {currentExam.totalCorrect}
                        </span>
                      </div>
                      <div className="flex flex-col items-center" data-id="element-1532">
                        <span className="text-sm text-gray-400" data-id="element-1533">Yanlış</span>
                        <span className="text-2xl font-bold text-red-500" data-id="element-1534">
                          {currentExam.totalWrong}
                        </span>
                      </div>
                      <div className="flex flex-col items-center" data-id="element-1535">
                        <span className="text-sm text-gray-400" data-id="element-1536">Boş</span>
                        <span className="text-2xl font-bold text-gray-500" data-id="element-1537">
                          {currentExam.totalEmpty}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Ders Bazlı Analiz Tablosu */}
              <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1538">
                <div className="p-6 bg-black/90 rounded-xl" data-id="element-1539">
                  <h2 className="text-xl font-bold mb-4" data-id="element-1540">Ders Bazlı Analiz</h2>
                  <div className="overflow-x-auto" data-id="element-1541">
                    <table className="w-full" data-id="element-1542">
                      <thead data-id="element-1543">
                        <tr className="border-b border-gray-800" data-id="element-1544">
                          <th className="px-4 py-3 text-left text-sm font-medium text-gray-400" data-id="element-1545">
                            Ders
                          </th>
                          <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-1546">
                            Doğru
                          </th>
                          <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-1547">
                            Yanlış
                          </th>
                          <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-1548">
                            Boş
                          </th>
                          <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-1549">
                            Net
                          </th>
                          <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-1550">
                            Başarı
                          </th>
                        </tr>
                      </thead>
                      <tbody data-id="element-1551">
                        {currentExam.subjects.map((subject, index) => {
                    const successRate = subject.net / subject.questions * 100;
                    const gradientClass = DERS_RENKLERI[subject.subject] || 'from-purple-600 to-indigo-600';
                    return <tr key={index} className="border-b border-gray-800" data-id="element-1552">
                              <td className="px-4 py-3 text-sm font-medium text-white" data-id="element-1553">
                                {subject.subject}
                              </td>
                              <td className="px-4 py-3 text-center text-sm text-green-500" data-id="element-1554">
                                {subject.correct}
                              </td>
                              <td className="px-4 py-3 text-center text-sm text-red-500" data-id="element-1555">
                                {subject.wrong}
                              </td>
                              <td className="px-4 py-3 text-center text-sm text-gray-500" data-id="element-1556">
                                {subject.empty}
                              </td>
                              <td className="px-4 py-3 text-center text-sm text-white" data-id="element-1557">
                                {subject.net.toFixed(2)}
                              </td>
                              <td className="px-4 py-3" data-id="element-1558">
                                <div className="flex items-center gap-2 justify-end" data-id="element-1559">
                                  <div className="w-32 h-2 bg-gray-800 rounded-full overflow-hidden" data-id="element-1560">
                                    <div className={`h-full bg-gradient-to-r ${gradientClass}`} style={{
                              width: `${successRate}%`
                            }} data-id="element-1561" />
                                  </div>
                                  <span className="text-xs text-white min-w-[45px] text-right" data-id="element-1562">
                                    {successRate.toFixed(1)}%
                                  </span>
                                </div>
                              </td>
                            </tr>;
                  })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* TASK 1: Replacing tabs with a centered dropdown menu */}
              <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1563">
                <div className="p-6 bg-black/90 rounded-xl" data-id="element-1564">
                  <h2 className="text-xl font-bold mb-6" data-id="element-1565">Konu Analizi</h2>
                  {/* Centered Subject Dropdown Menu */}
                  <div className="flex justify-center mb-6" data-id="element-1566">
                    <div className="relative w-full max-w-xs" data-id="element-1567">
                      <button onClick={() => setShowSubjectDropdown(!showSubjectDropdown)} className="w-full flex items-center justify-between gap-2 px-4 py-3 bg-black/80 rounded-lg border border-purple-500/30 hover:border-purple-500/50 transition-colors" data-id="element-1568">
                        <span className="text-white" data-id="element-1569">{activeSubjectTab}</span>
                        <ChevronDown className={`w-5 h-5 text-purple-400 transition-transform ${showSubjectDropdown ? 'rotate-180' : ''}`} data-id="element-1570" />
                      </button>
                      {showSubjectDropdown && <div className="absolute top-full left-0 mt-1 z-10 w-full bg-gray-900/95 border border-gray-700 rounded-lg shadow-lg py-1 max-h-60 overflow-y-auto" data-id="element-1571">
                          {currentExam.subjects.map(subject => {
                    const isSelected = activeSubjectTab === subject.subject;
                    const gradientClass = DERS_RENKLERI[subject.subject] || 'from-purple-600 to-indigo-600';
                    return <button key={subject.subject} onClick={() => {
                      setActiveSubjectTab(subject.subject);
                      setShowSubjectDropdown(false);
                    }} className={`w-full text-left px-4 py-2 transition-colors ${isSelected ? 'bg-purple-500/20 text-purple-400' : 'text-white hover:bg-purple-500/10'}`} data-id="element-1572">
                                {subject.subject}
                              </button>;
                  })}
                        </div>}
                    </div>
                  </div>
                  {/* Topic List with Statistics */}
                  <div className="overflow-x-auto" data-id="element-1573">
                    <table className="w-full" data-id="element-1574">
                      <thead data-id="element-1575">
                        <tr className="border-b border-gray-800" data-id="element-1576">
                          <th className="px-4 py-3 text-left text-sm font-medium text-gray-400" data-id="element-1577">
                            Konu
                          </th>
                          <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-1578">
                            Doğru
                          </th>
                          <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-1579">
                            Yanlış
                          </th>
                          <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-1580">
                            Boş
                          </th>
                          <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-1581">
                            Net
                          </th>
                          <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-1582">
                            Başarı
                          </th>
                        </tr>
                      </thead>
                      <tbody data-id="element-1583">
                        {getTopicsForActiveSubject().map((topic, index) => {
                    const gradientClass = DERS_RENKLERI[activeSubjectTab] || 'from-purple-600 to-indigo-600';
                    const successRate = topic.questions > 0 ? topic.net / topic.questions * 100 : 0;
                    return <tr key={index} className="border-b border-gray-800" data-id="element-1584">
                              <td className="px-4 py-3 text-sm font-medium text-white" data-id="element-1585">
                                {topic.topic}
                              </td>
                              <td className="px-4 py-3 text-center text-sm text-green-500" data-id="element-1586">
                                {topic.correct}
                              </td>
                              <td className="px-4 py-3 text-center text-sm text-red-500" data-id="element-1587">
                                {topic.wrong}
                              </td>
                              <td className="px-4 py-3 text-center text-sm text-gray-500" data-id="element-1588">
                                {topic.empty}
                              </td>
                              <td className="px-4 py-3 text-center text-sm text-white" data-id="element-1589">
                                {topic.net?.toFixed(2) || '0.00'}
                              </td>
                              <td className="px-4 py-3" data-id="element-1590">
                                <div className="flex items-center gap-2 justify-end" data-id="element-1591">
                                  <div className="w-32 h-2 bg-gray-800 rounded-full overflow-hidden" data-id="element-1592">
                                    <div className={`h-full bg-gradient-to-r ${gradientClass}`} style={{
                              width: `${successRate}%`
                            }} data-id="element-1593" />
                                  </div>
                                  <span className="text-xs text-white min-w-[45px] text-right" data-id="element-1594">
                                    {successRate.toFixed(1)}%
                                  </span>
                                </div>
                              </td>
                            </tr>;
                  })}
                        {getTopicsForActiveSubject().length === 0 && <tr data-id="element-1595">
                            <td colSpan={6} className="px-4 py-8 text-center text-gray-400" data-id="element-1596">
                              Bu ders için konu analizi bulunmuyor.
                            </td>
                          </tr>}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>}
        </div>}
      {activeTab === 'topic' && <div className="space-y-6" data-id="element-1597">
          {/* Ders Seçimi - Improved dropdown styling */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-1598">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-1599">
              <h2 className="text-xl font-bold mb-4" data-id="element-1600">Konu Bazlı Analiz</h2>
              <div className="flex justify-center mb-6" data-id="element-1601">
                <div className="relative w-full max-w-xs" data-id="element-1602">
                  <button onClick={() => setShowSubjectDropdown(!showSubjectDropdown)} className="w-full flex items-center justify-between gap-2 px-4 py-3 bg-black/80 rounded-lg border border-purple-500/30 hover:border-purple-500/50 transition-colors" data-id="element-1603">
                    <span className="text-white" data-id="element-1604">{selectedTopicSubject}</span>
                    <ChevronDown className={`w-5 h-5 text-purple-400 transition-transform ${showSubjectDropdown ? 'rotate-180' : ''}`} data-id="element-1605" />
                  </button>
                  {showSubjectDropdown && <div className="absolute top-full left-0 mt-1 z-10 w-full bg-gray-900/95 border border-gray-700 rounded-lg shadow-lg py-1 max-h-60 overflow-y-auto" data-id="element-1606">
                      {Object.keys(topicAnalysisData).map(subject => {
                  const isSelected = selectedTopicSubject === subject;
                  return <button key={subject} onClick={() => {
                    setSelectedTopicSubject(subject);
                    setShowSubjectDropdown(false);
                  }} className={`w-full text-left px-4 py-2 transition-colors ${isSelected ? 'bg-purple-500/20 text-purple-400' : 'text-white hover:bg-purple-500/10'}`} data-id="element-1607">
                            {subject}
                          </button>;
                })}
                    </div>}
                </div>
              </div>
              {/* Seçilen dersin konu analizi - Fixed percentage display */}
              <div className="overflow-x-auto" data-id="element-1608">
                <table className="w-full" data-id="element-1609">
                  <thead data-id="element-1610">
                    <tr className="border-b border-gray-800" data-id="element-1611">
                      <th className="px-4 py-3 text-left text-sm font-medium text-gray-400" data-id="element-1612">
                        Konu
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-1613">
                        Doğru
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-1614">
                        Yanlış
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-1615">
                        Boş
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-1616">
                        Toplam Soru
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-1617">
                        Başarı
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-1618">
                    {topicAnalysisData[selectedTopicSubject].map((topic, index) => {
                  const gradientClass = DERS_RENKLERI[selectedTopicSubject] || 'from-purple-600 to-indigo-600';
                  return <tr key={index} className="border-b border-gray-800" data-id="element-1619">
                            <td className="px-4 py-3 text-sm font-medium text-white" data-id="element-1620">
                              {topic.topic}
                            </td>
                            <td className="px-4 py-3 text-center text-sm text-green-500" data-id="element-1621">
                              {topic.correct}
                            </td>
                            <td className="px-4 py-3 text-center text-sm text-red-500" data-id="element-1622">
                              {topic.wrong}
                            </td>
                            <td className="px-4 py-3 text-center text-sm text-gray-500" data-id="element-1623">
                              {topic.empty}
                            </td>
                            <td className="px-4 py-3 text-center text-sm text-white" data-id="element-1624">
                              {topic.totalQuestions}
                            </td>
                            <td className="px-4 py-3" data-id="element-1625">
                              <div className="flex items-center gap-2 justify-end" data-id="element-1626">
                                <div className="w-32 h-2 bg-gray-800 rounded-full overflow-hidden" data-id="element-1627">
                                  <div className={`h-full bg-gradient-to-r ${gradientClass}`} style={{
                            width: `${topic.accuracy}%`
                          }} data-id="element-1628" />
                                </div>
                                <span className="text-xs text-white min-w-[45px] text-right" data-id="element-1629">
                                  {topic.accuracy.toFixed(1)}%
                                </span>
                              </div>
                            </td>
                          </tr>;
                })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}